import React, { useState } from "react";

import PokerTable from "./PokerTable";
import HandTable from "./HandTable";

const Poker = ({ userData }) => {
  const [activeSection, setActiveSection] = useState("Poker Table");
  const [handData, setHandData] = useState(null);

  return (
    <>
      {activeSection === "Poker Table" && (
        <PokerTable
          userData={userData}
          setActiveSection={setActiveSection}
          setHandData={setHandData}
        />
      )}
      {activeSection === "Hand Table" && (
        <HandTable
          userData={userData}
          handData={handData}
          setActiveSection={setActiveSection}
        />
      )}
    </>
  );
};

export default Poker;
